import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { AssociativaContropartiForm } from '../../../form/associativa-controparti-form';
import { Controparte } from '../../../models/controparte';
import { SezioneContropartiResponse } from '../../../models/dto/sezione-controparti-response';
import { Parte } from '../../../models/parte';
import { SezioneControparti } from '../../../models/sezioni/sezione-controparti';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';

@Component({
    selector: 'div [associativa-controparti-form-add]',
  templateUrl: '../../../form/associativa-controparti-form.html',
})
export class ContropartiAssociativaAddComponent extends AssociativaContropartiForm  implements OnInit {
  addControparteUrl: string;
  idSezione: string;
  idFascicolo: string;
  @Input() isPatologia: boolean;
  @Input() isAttore: boolean;
  @Output() onReturn: EventEmitter<SezioneControparti> = new EventEmitter<SezioneControparti>();
  @Output() onReturnControparte: EventEmitter<Controparte> = new EventEmitter<Controparte>();

  ngOnInit() {
    this.isInserimento(true);
  }

  constructor(@Inject(FormBuilder) campiForm: FormBuilder, @Inject(OperationsService) operationService: OperationsService,
     @Inject(HelpersService) helpers: HelpersService, @Inject(ActivatedRoute) activatedRoute: ActivatedRoute,
     @Inject(ModalNotifyService) modalNotifyService: ModalNotifyService,@Inject(Router) router: Router) {
      super(campiForm, operationService, helpers, activatedRoute,modalNotifyService,router);
  }

  getRequest(request: Controparte) {
      this.operationService.addParteOrLegaleInSezOrdinario(request, this.addControparteUrl, this.idSezione, this.idFascicolo).subscribe(
        response => {
          if (!this.isPatologia) {
            this.addedControparti(<SezioneContropartiResponse>response);
          } else {
            this.onReturnControparte.emit(request);
          }
        });
  }

  addedControparti(response: SezioneContropartiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  getControparte(): Controparte {
    return new Controparte();
  }

  inizializza(parte: Parte, addControparteUrl: string, idSezione: string, idFascicolo: string) {
    this.flagAttore = this.isAttore;
    this.idSezione = idSezione;
    this.idFascicolo = idFascicolo;
    this.addControparteUrl = addControparteUrl;
    this.setParte(parte);
    this.populateSelect();
    this.createForm();
  }

  canCheckPrimary(): boolean {
    return true;
  }
}
